/**
 * @Create idler.zhu(zqc.sunny@aliyun.com)
 * @CreateDate  2017/12/11
 */
import './index.css';
import React from 'react';
import { connect } from 'react-redux';

const Bread = ({ list, action = 1, queryKey }) => {
  return <nav className="mcycle-bread">
    {
      action === 3 ? <a className="mcycle-bread-item back-home" href="//mcycle.meizu.com/">返回首页</a> :
      <div>
        <a className="mcycle-bread-item" href="//store.meizu.com/">首页</a>
        <a className="mcycle-bread-item" href="//mcycle.meizu.com/">以旧换新</a>
        <a className="mcycle-bread-item" href="javascript:void(0);">{ action === 0 ? `搜索 "${queryKey}" 的结果` : list[action]}</a>
      </div>
    }
  </nav>
};

export default connect(
  state => state.app.navigation
)(Bread);



// WEBPACK FOOTER //
// ./src/components/step/bread/index.js